// globals
import "./modal";
import "./header";
import "./flickity";
import "./accordion";
import "./osaka-bay-banner";
import "./select-reload-page";
import "./fileUpload";